import { sample } from 'effector';
import { createAddBonusModel } from 'features/add-bonus';
import { createBlockBonusModel } from 'features/block-bonus';
import { createDeleteBonusModel } from 'features/delete-bonus';
import { createEditBonusModel } from 'features/edit-bonus';
import { createUnblockBonusModel } from 'features/unblock-bonus';
import { accountTreeModel } from 'entities/account';
import { createBonusRegistryModel } from 'entities/bonus';
import { accountPageModel } from './account-page-model';

const addBonusModel = createAddBonusModel();

const editBonusModel = createEditBonusModel();

const blockBonusModel = createBlockBonusModel();

const unblockBonusModel = createUnblockBonusModel();

const deleteBonusModel = createDeleteBonusModel();

const bonusRegistryModel = createBonusRegistryModel({
	$accountId: accountPageModel.$accountId,
	$currencies: accountTreeModel.$currencies,
	onDelete: [deleteBonusModel.mutation.finished.success],
	onUpdate: [
		accountPageModel.accountIdSet,
		addBonusModel.addBonusMutation.finished.success,
		editBonusModel.editBonusMutation.finished.success,
		blockBonusModel.mutation.finished.success,
		unblockBonusModel.mutation.finished.success,
	],
});

sample({
	clock: addBonusModel.getAccountsQuery.finished.success,
	source: accountPageModel.$accountId,
	filter: Boolean,
	target: addBonusModel.form.fields.accountId.setValue,
});

export const accountPageBonusModel = {
	bonusRegistryModel,
	addBonusModel,
	editBonusModel,
	blockBonusModel,
	unblockBonusModel,
	deleteBonusModel,
};
